export default "__VITE_ASSET__CVLd10jc__"